import apiClient from "./client";

export function uploadAudio(blob, filename = "audio.webm") {
  const file = blob instanceof File ? blob : new File([blob], filename, { type: blob.type || "audio/webm" });
  const formData = new FormData();
  formData.append("file", file);
  return apiClient
    .post("/audio/upload", formData, {
      transformRequest: (data, headers) => {
        delete headers["Content-Type"];
        return data;
      },
    })
    .then((r) => r.data?.url || r.data);
}
